'use client';
import React, { useState, forwardRef, useEffect } from 'react';

import { Image } from '@/components/shared/Image';
import { cn } from '@/lib/utils/cn';
import { C_DEFAULT_AVATAR } from '@/ts/constants/C_AVATARS';

export interface I_UserAvatarProps {
  src?: string | null;
  alt?: string;
  className?: string;
  width?: number;
  height?: number;
  fallbackSrc?: string;
  priority?: boolean;
  loading?: 'lazy' | 'eager';
}

export const UserAvatar = forwardRef<HTMLImageElement, I_UserAvatarProps>(
  (
    {
      src,
      alt = 'Avatar',
      className,
      width,
      height,
      fallbackSrc = C_DEFAULT_AVATAR,
      priority = false,
      loading = 'lazy',
      ...props
    },
    ref
  ) => {
    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
      setImageError(true);
    };

    useEffect(() => {
      setImageError(false);
    }, [src]);

    const imageSrc = imageError ? fallbackSrc : src || fallbackSrc;

    return (
      <div className={cn('relative ', className)}>
        <Image
          ref={ref}
          src={imageSrc}
          alt={alt}
          className={cn('rounded-full w-full h-full border-2', className)}
          width={width}
          height={height}
          priority={priority}
          loading={loading}
          onError={handleImageError}
          {...props}
        />
      </div>
    );
  }
);

UserAvatar.displayName = 'UserAvatar';
